import React from 'react';
import { Box, Icon, Text, Tooltip } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { useCurrencyDisplay, useStoreInfo } from 'commons/hooks';
import { Currency } from 'commons/types/Currency.enum';

interface CurrencyDisplayProps {
  currency: Currency;
  exchangeRate?: number;
  value: number;
  justifyContent?: 'center' | 'flex-end';
  showWithExchangeRate?: boolean;
  showTooltip?: boolean;
}

const CurrencyDisplay = ({
  currency,
  exchangeRate,
  value,
  justifyContent = 'center',
  showWithExchangeRate = false,
  showTooltip = false,
}: CurrencyDisplayProps) => {
  const { storeInfo } = useStoreInfo();

  const { displayValue, isForeign, tooltipContent } = useCurrencyDisplay({
    currency,
    exchangeRate,
    value,
    storeInfo,
    showWithExchangeRate,
    showTooltip,
  });

  if (!isForeign) {
    return <Text data-testid="currency-display-formatted">{displayValue}</Text>;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="1"
      justifyContent={justifyContent}
      data-testid="currency-display-container"
    >
      <Text data-testid="currency-display-formatted">{displayValue}</Text>
      {tooltipContent && (
        <Tooltip content={tooltipContent}>
          <Icon
            source={<InfoCircleIcon />}
            data-testid="currency-display-info-icon"
            aria-label={`Exchange rate information: ${tooltipContent}`}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default CurrencyDisplay;
